import { User } from "../entity/User";
import { CACHE_KEYS, CacheManager } from "../services/local/CacheManager";

export const requiredRole = async (userRole: string): Promise<boolean> => {
  const cacheManagerInstance = CacheManager.getInstance();
  const user = await cacheManagerInstance.get<User>(CACHE_KEYS.USER_PROFILE);

  return user?.role === userRole;
};

export const requiredRoles = async (userRoles: string[]): Promise<boolean> => {
  const cacheManagerInstance = CacheManager.getInstance();
  const user = await cacheManagerInstance.get<User>(CACHE_KEYS.USER_PROFILE);

  // If no user or no role, return false
  if (!user || !user.role) {
    return false;
  }
  // Check if user's role is in the allowed roles array
  return userRoles.includes(user.role);
};
